import {Button, HStack} from '@chakra-ui/react';
import {FC} from 'react';
import {TranslationKeys} from 'translations';

interface IProps {
  t: (term: TranslationKeys) => string;
  resetOrdering: () => void;
  handleSubmit: () => void;
}

export const OptionsButtonsGroup: FC<IProps> = ({t, resetOrdering, handleSubmit}) => {
  return (
    <HStack spacing="15px" w="full">
      <Button onClick={resetOrdering} variant="outline" flex="1">
        {t('FILTER_RESET')}
      </Button>
      <Button variant="primary" flex="1" onClick={handleSubmit}>
        {t('APPLY')}
      </Button>
    </HStack>
  );
};
